/*
 * Devuelve un filter cloneado y limpio para enviar a Ediwin
 * En particular, limpia los "IN" con array vacios que no hay que enviar.
 */
export default function cloneFilter(filter) {
  const clone = {
    filterCriteria: cloneFilterCriteria(filter.filterCriteria),
    orderBy: filter.orderBy || null,
    groupBy: filter.groupBy || null,
  };
  if (filter.from) {
    clone.from = filter.from;
  }
  if (filter.to) {
    clone.to = filter.to;
  }
  return clone;

  /////////////////////////////////////////////////////////////////////////////////////////

  function cloneFilterCriteria({ children, criteria = null, union = null } = {}) {
    return {
      children: (children || [])
        .filter(isFilterCriteria)
        .reduce((acc, cur) => [...acc, cloneFilterCriteria(cur)], [])
        .filter(isFilterCriteria), // filtramos los IN con v2=[] vacios.
      criteria: cloneCriteria(criteria),
      union,
    };

    function isFilterCriteria(filterCriteria) {
      if (!filterCriteria) {
        return false;
      }
      const isChildren =
        filterCriteria.children && Array.isArray(filterCriteria.children) && filterCriteria.children.length;
      const isCriteria = !!filterCriteria.criteria;
      return isChildren || isCriteria;
    }

    function cloneCriteria(criteria) {
      if (!criteria) {
        return null;
      }
      const { v1, op, v2 } = criteria;
      // if ((op === OP.IN || op === OP.NOT_IN) && !(v2 && Array.isArray(v2) && v2.length)) return null;
      return { v1, op, v2 };
    }
  }
}
